import { localStorageKeys } from '../Constants';

export class LocalStorageManager {
    screenName: string;
    storageList = {
        [localStorageKeys.TICKET_INFO_DATA]: {
            canGetScreenList: ['BuyTicketInfoScreen', 'BuyCreditCardPaymentScreen', 'ReservationTicketInfoScreen'],
            canSetScreenList: ['BuyTicketInfoScreen', 'useTicketInfo', 'ReservationTicketInfoScreen'],
            canRemoveScreenList: ['BuyTicketItem'],
        },
        [localStorageKeys.USER_INFO_FORM]: {
            canGetScreenList: ['ReservationUserInfoScreen', 'ReservationTicketInfoScreen'],
            canSetScreenList: ['ReservationUserInfoScreen'],
            canRemoveScreenList: ['ReservationUserInfoScreen', 'ReservationTicketInfoScreen'],
        },
    };
    constructor(screenName: string) {
        this.screenName = screenName;
    }
    getStorage(storageKey: string) {
        if (
            !this.storageList[storageKey]?.canGetScreenList?.includes(this.screenName) &&
            this.storageList[storageKey]?.canGetScreenList?.length > 0
        ) {
            return null;
        }
        return JSON.parse(localStorage.getItem(storageKey) ?? '{}');
    }
    setStorage(storageKey: string, storageValue: any) {
        if (!this.storageList[storageKey]?.canSetScreenList?.includes(this.screenName)) {
            console.log('「Local Storage」にこのkeyを追加できません。LocalStorageManagerのstorageListを確認ください。');
            return;
        }
        localStorage.setItem(storageKey, JSON.stringify(storageValue));
    }
    removeStorage(storageKey: string) {
        if (!this.storageList[storageKey]?.canRemoveScreenList?.includes(this.screenName)) {
            console.log('「Local Storage」にこのkeyを削除できません。LocalStorageManagerのstorageListを確認ください。');
            return;
        }
        localStorage.removeItem(storageKey);
    }
}
